import _                           from 'lodash'
import PropTypes                   from 'prop-types'
import React                       from 'react'
import { Route, Redirect, Switch } from 'react-router-dom'

export redirectPreservingQuery = (path) ->
  query = window.location.search

  <Redirect to={{ pathname: path, search: query }} />

export RouteWithProps = (props) ->
  routeProps = ['path', 'exact', 'strict', 'sensitive', 'location', 'computedMatch']

  <Route {..._.pick(props, routeProps)}
   render={-> <props.component {..._.omit(props, 'component', routeProps)} />} />

fallbackType = PropTypes.oneOfType([PropTypes.string, PropTypes.func])

export class SwitchWithFallback extends React.Component
  @contextTypes:      { fallback: fallbackType }
  @childContextTypes: { fallback: fallbackType }

  getChildContext: -> { fallback: @props.fallback ? @context.fallback }

  render: ->
    fb       = @props.fallback ? @context.fallback
    fallback = if _.isString(fb) then -> redirectPreservingQuery(fb) else fb

    <Switch>
      {@props.children}

      <Route component={fallback} />
    </Switch>
